module.exports = __webpack_public_path__ + "img/ma241.3fc97df8.png";